import React from 'react'

const ResultsList = ({data, tabType, texts}) => {
    return (
        <React.Fragment>
            {data.map(({id, image, category_name, url, date, place ,online, type, title}, cnt)=>{
                /* Transform date
                
                let dateStart = new Date(start_at);
                let dateEnd = new Date(end_at);
                let shortMonthStart = dateStart.toLocaleString('en-us', { month: 'short' });
                let shortMonthEnd = dateEnd.toLocaleString('en-us', { month: 'short' });
                let dayStart = dateStart.getDate();
                let dayEnd = dateEnd.getDate();
                let eventDate = dayStart == dayEnd && shortMonthStart == shortMonthEnd ? 
                    `${dayStart} ${shortMonthStart}` :
                    `${dayStart} ${shortMonthStart} - ${dayEnd} ${shortMonthEnd}`;
                */
                return (
                    <li className="list-group-item result-list-item" key={`result-item-${tabType}-${cnt}`}>
                        <a className="d-flex flex-column flex-sm-row" href={url}>
                            <div className="search-result-image" style={{backgroundImage: `url(${image ? image : '/img/test/test.png'})`}}></div>
                            <div className="card-body e-card">
                                <h6 className="card-subtitle mb-2 text-muted">{tabType == 'event' ? category_name : type }</h6>
                                <div className="card-text text-dark">{title}</div>
                                <div className="d-flex align-items-baseline">
                                    <span className="date me-3">{date}</span>
                                    <span className="location me-4">{place}</span>
                                    {online ? <span className="online pink-dot-before text-uppercase search-result-tag">{texts.online}</span> : ''}
                                </div>
                            </div>
                        </a>
                    </li>
                )
            }
            )}
        </React.Fragment>
    )
}

export default ResultsList;